<script>

    import { toast } from 'bulma-toast'

    import TilService from '../$services/til.service'

    import Button from '../$components/button.svelte'
    import SelectOwners from '../$components/select.owners.svelte'
    import Form from '../$components/form.svelte'

    let query = {
        ownerId: '60edc374e9091e00151699c0'
    }

    let loading = false
    let element = null

    async function downloadTilPricing() {

        loading = true
        const blob = await TilService.downloadTilPricing(query)
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar el archivo', type: 'is-danger'})

        element.download = 'precios_til.xlsx'
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Form on:submit={downloadTilPricing} {loading} >
    <div class="columns">
        <div class="column">
            <SelectOwners bind:ownerId={query.ownerId} label="Propietario" />
        </div>
    </div>
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button type="submit" text="Descargar precios" icon="download" />
    </div>
</Form>
